// Constants
export const garantia_antecedentes = () => {
  return {
    garantia_antecedentes: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        dataform: ['paciente_garantias','orden_garantias'],
        datatype: {
          predeterminate: ''
        }
      },
      id_info_garantia:{
        type: 'number',
        label: 'Tipo',
        placeholder: '',
        description: 'key forein info_examens',
        readonly: true,
        dataform: ['paciente_garantias','orden_garantias'],
        datatype: { 
          predeterminate: '',
        }
      },
      familiares: {
        type: 'boolean',
        label: 'Antecedentes Familiares',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Antecedentes Familiares',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      personales: {
        type: 'boolean',
        label: 'Antecedentes Personales',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Antecedentes Personales',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      ocupacionales: {
        type: 'boolean',
        label: 'Antecedentes Ocupacionales',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Antecedentes Ocupacionales',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      exposicion: {
        type: 'boolean',
        label: 'Exposicion Laboral Visual',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Exposicion laboral visual',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      lentes: {
        type: 'boolean',
        label: 'Lentes De Contacto',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Lentes De Contacto',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      multifocal: {
        type: 'boolean',
        label: 'Multifocal',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Multifocal',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      uso: {
        type: 'boolean',
        label: 'Antecedentes Ocupacionales',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Antecedentes Ocupacionales',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      rx: {
        type: 'boolean',
        label: 'Trae RX',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Trae RX',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      diagnostico: {
        type: 'boolean',
        label: 'Ultimo Diagnostico',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Ultimo Diagnostico',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      anteojos: {
        type: 'boolean',
        label: 'Usa Anteojos',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Usa Anteojos',
        validate: '',
        datatype: 
        {
          type: 'check',
          disabled: false,
          predeterminate: false,
        }
      },
      descripcion: {
        type: 'text',
        label: 'Descripcion',
        dataform: ['paciente_garantias','orden_garantias'],
        placeholder: '',
        description: 'Descripcion',
        validate: '',
        datatype: 
        {
          type: 'textarea',
          disabled: false,
          predeterminate: '',
        }
      },
    }
  }
}

export function asign_garantia_antecedentes(){
  var asign= Object.keys(garantia_antecedentes().garantia_antecedentes);
  var objeto = garantia_antecedentes().garantia_antecedentes
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}

